import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "setting",
  "use": "setting-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"setting\"><path d=\"M16.845 20.392h-9.69L2.309 12l4.846-8.393h9.69L21.691 12l-4.846 8.392zM23.423 13a2 2 0 0 0 0-2l-4.846-8.393a2 2 0 0 0-1.732-1h-9.69a2 2 0 0 0-1.732 1L.577 11a2 2 0 0 0 0 2l4.846 8.392a2 2 0 0 0 1.732 1h9.69a2 2 0 0 0 1.732-1L23.423 13z\" /><path d=\"M12 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol